import { render } from "@testing-library/react";
import { Table, Pagination, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
// import { FaEye } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import "../../../App.css";
import dayjs from "dayjs";
import ModalPopup from "../../Common/Modal/Modal";
import DeleteList from "../DeleteList";
import {
  ChangeRedeemStatus,
  GetRedeemOffersData,
} from "../../../Api/Offers/RedeemOffers";
import { useDispatch } from "react-redux";
import Direction from "../../../asserts/direction.png";
// import Pagination from "../Common/Pagination";
import { CiImageOff } from "react-icons/ci";
import { capitalizeFirstLetter } from "../../Common/Captilization";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";

export default function RedeemListView({
  currentData,
  setModalIsOpen,
  SetUpdateData,
  activePage,
  itemsPerPage,
  offerimage,
  setOfferImage,
  setOfferView,
  offerview,
  offerFilter,
  handleOfferTitleSort,
  sortOrderOfferTitle,
  handleOfferCodeSort,
  sortOrderOfferCode,
  handleOfferCatSort,
  sortOrderOfferCat,
  handleOfferDateSort,
  sortOrderOfferDate,
  handleOfferDurationSort,
  sortOrderOfferDuration,
  handleOfferUsageSort,
  sortOrderOfferUsage,
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;

  const typeId = sessionStorage.getItem("type_id")
    ? sessionStorage.getItem("type_id")
    : localStorage.getItem("type_id");

  const [promotionid, setPromoId] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [comment, setComment] = useState();
  const [error, setError] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  const [statusId, setStatusId] = useState();
  const [offId, setOffId] = useState();
  const [id, setId] = useState();
  const [maxError, setMaxError] = useState();
   const loadCrud = () => {
  const raw = sessionStorage.getItem("crud_permission");
  if (!raw) {
    return ["create", "view", "update", "delete"];
  }
  return raw
    .split(",")
    .map(x => x.trim())
    .filter(Boolean);
};
const crud = loadCrud();
const canCreate = crud?.includes("create");
const canView   = crud?.includes("view");
const canUpdate = crud?.includes("update");
const canDelete = crud?.includes("delete");

  const statusUpdate = (statusid, offerid) => {
    if (typeId === "PRO101") {
      setStatusModal(true);
      setStatusId(statusid);
      setOffId(offerid);
    }
  };

  const showComment =
    typeId === "PRO101"
      ? offerFilter === "rejected" ||
        offerFilter === "hold" ||
        offerFilter === "approved" ||
        offerFilter === "all"
      : false;

  const CloseStatusModal = () => {
    setStatusModal(false);
    if (statusModal === false) {
      setError("");
    }
  };

  useEffect(() => {
    if (statusModal === false) {
      setError("");
      setComment("");
    }
  }, [statusModal]);

  const dispatch = useDispatch();

  const handleStatusChange = async (id) => {
    setId(id);
    if ((id === 3 || id === 4) && (!comment || comment.trim().length === 0)) {
      setError("Reason required for Hold or Reject");
      return;
    }

    if ((id === 3 || id === 4) && (!comment || comment.length > 25)) {
      setMaxError(true);
      return;
    } else {
      setMaxError(false);
    }

    ChangeRedeemStatus(id, offId, dispatch, offerFilter, comment);
    GetRedeemOffersData(dispatch, offerFilter);
    console.log("call 1");
    setStatusModal(false);
    setComment("");
  };

  const columns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + (index + 1);
        return (
          <div className="">
            {/* <h1 className="pl-[2vw] text-[1.1vw]">{index + 1}</h1> */}
            <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
              {serialNumber}
            </h1>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly ">
          Offer Title
          <button onClick={handleOfferTitleSort} className="">
                                {sortOrderOfferTitle === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferTitle === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferTitle === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      // sorter: (a, b) => a.offer_name.localeCompare(b.offer_name),
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center pl-[2vw]">
            {/* <h1 className="text-[1.1vw]">{row.offer_name}</h1> */}
            {row?.offer_name?.length > 15 ? (
              <Tooltip
                placement="bottom"
                title={row?.offer_name}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {" "}
                  {`${capitalizeFirstLetter(row?.offer_name?.slice(0, 15))}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {capitalizeFirstLetter(row?.offer_name?.slice(0, 15))}
              </h1>
            )}
          </div>
        );
      },
      width: "18vw",
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly">
          Offer Code
          <button onClick={handleOfferCodeSort} className="">
                                {sortOrderOfferCode === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferCode === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferCode === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      width: "15vw",
      // sorter: (a, b) => a.code.localeCompare(b.code),
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.code?.length > 8 ? (
              <Tooltip
                placement="top"
                title={row?.code}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <div className="border-[0.1vw] border-[#1F487C] rounded-[0.5vw]">
                  <div className="border-dashed text-[1vw]  font-bold bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[10vw] flex items-center justify-center">
                    {`${
                      row?.code?.charAt(0) ===
                      row?.code?.charAt(0)?.toLowerCase()
                        ? capitalizeFirstLetter(row?.code).slice(0, 8)
                        : row?.code?.slice(0, 8)
                    }...`}
                  </div>
                </div>
              </Tooltip>
            ) : (
              <div className="border-[0.1vw] border-[#1F487C] rounded-[0.5vw]">
                <div className="border-dashed text-[1vw] font-bold bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[10vw] flex items-center justify-center ">
                  {row?.code?.charAt(0) === row?.code?.charAt(0)?.toLowerCase()
                    ? capitalizeFirstLetter(row?.code)
                    : row?.code}
                </div>
              </div>
            )}
            {/* <button className="border-dashed text-[1.1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[14vw] ">
              {row.code}
            </button> */}
          </div>
        );
      },
    },

    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly">
          Category
          <button onClick={handleOfferCatSort} className="">
                                {sortOrderOfferCat === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferCat === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferCat === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      width: "15vw",
      // sorter: (a, b) => a.occupation.localeCompare(b.occupation),
      onHeaderCell: () => ({
        style: { transform: "none", transition: "none" },
      }),
      render: (row) => {
        return (
          <div className="flex items-center pl-[2vw]">
            <p className="text-[1vw] font-bold text-[#1F487C]">
              {row.occupation}
            </p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly">
          Created Date
          <button onClick={handleOfferDateSort} className="">
                                {sortOrderOfferDate === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferDate === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferDate === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      // sorter: (a, b) =>
      //   dayjs(a.created_date).valueOf() - dayjs(b.created_date).valueOf(),
      width: "15vw",
      render: (row) => {
        return (
          <div className="flex items-center pl-[2.5vw]">
            <p className="text-[1vw] text-[#1F487C]">{`${dayjs(
              row?.created_date
            ).format("DD MMM, YY")}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly">
          Duration
          <button onClick={handleOfferDurationSort} className="">
                                {sortOrderOfferDuration === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferDuration === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferDuration === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      // sorter: (a, b) => dayjs(a?.start_date).diff(dayjs(b?.start_date)),
      width: "15vw",
      render: (row) => {
        return (
          <div>
            <p className="text-[1vw] text-[#1F487C] flex pl-[2vw]">{`${dayjs(
              row?.start_date
            ).format("DD MMM")} - ${dayjs(row?.expiry_date).format(
              "DD MMM"
            )}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-evenly">
          Usage
          <button onClick={handleOfferUsageSort} className="">
                                {sortOrderOfferUsage === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferUsage === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferUsage === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    overlayStyle={{pointerEvents:'none'}}
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      width: "10vw",
      // sorter: (a, b) => {
      //   const usageA =
      //     typeof a?.usage === "string" ? a.usage : String(a?.usage || "");
      //   const usageB =
      //     typeof b?.usage === "string" ? b.usage : String(b?.usage || "");
      //   return usageA.localeCompare(usageB);
      // },
      render: (row) => {
        return (
          <div>
            <p className="text-[1vw] text-[#1F487c] pl-[2.75vw]  ">
              {`0/${row.usage}`}
            </p>
          </div>
        );
      },
    },
    ...(showComment
      ? [
          {
            title: (
              <h1 className="text-[1.1vw] font-bold text-center  flex items-center justify-center">
                Comments
              </h1>
            ),
            width: "9vw",
            render: (row) => {
              return (
                <>
                  {row?.req_status === "Active" ||
                  row?.req_status === "Draft" ? (
                    <div className="flex items-center justify-center">-</div>
                  ) : row.comments ? (
                    <div className="flex items-center pl-[1.5vw]">
                      {row?.comments?.length > 10 ? (
                        <Tooltip
                          placement="top"
                          title={row?.comments}
                          className="cursor-pointer text-[#1F487C]"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <p className="text-[1vw] text-[#1F487C]">
                            {" "}
                            {`${capitalizeFirstLetter(
                              row?.comments?.slice(0, 10)
                            )}...`}
                          </p>
                        </Tooltip>
                      ) : (
                        <h1 className="text-[1vw] text-[#1F487C]">
                          {capitalizeFirstLetter(row?.comments?.slice(0, 10))}
                        </h1>
                      )}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">-</div>
                  )}
                </>
              );
            },
          },
        ]
      : ""),
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center  flex items-center justify-center">
          Status
        </h1>
      ),
      width: "9vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <button
             disabled={!canUpdate}
              onClick={() => {
                statusUpdate(row?.status_id, row?.tbs_offer_id);
                setComment(row?.comments);
                setStatusId(row.status_id)
              }}
              className={`${
                row?.status_id == 2
                  ? "bg-[#34AE2B]"
                  : row?.status_id == 0
                  ? "bg-[#646262]"
                  : row?.status_id == 1
                  ? "bg-[#FF9900]"
                  : row?.status_id == 3
                  ? "bg-[#2A99FF]"
                  : "bg-[#FD3434]"
              } rounded-[0.5vw] text-[1vw]  font-extrabold shadow-md shadow-black text-white w-[7vw] py-[0.2vw] ${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
            >
              {/* {typeId === "PRO101"
                ? row?.req_status_id === 1
                  ? row?.req_status
                  : row?.status
                : row?.status} */}
              {typeId === "PRO101" && row?.req_status_id === 6
                ? row?.req_status
                : row?.status}
            </button>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center  flex items-center justify-center">
          Actions
        </h1>
      ),
      width: "10vw",
      render: (row) => {
        console.log(row, "rowrowrowrow");
        return (
          <div className="grid grid-cols-3 gap-[0.4vw] items-center justify-center px-[1vw]">
            <FaEye
              size={"1.3vw"}
              color="#1F4B7F"
              className="cursor-pointer"
              onClick={() => {
                setOfferView(true);
                setOfferImage(row.theme);
              }}
            />
            {typeId === "PROEMP101" ? (
              row.status_id === 0 || row.status_id === 1 ? (
                <MdEdit
                  size={"1.3vw"}
                  color="#1F4B7F"
                  className={`${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                  onClick={() => {
                    if(!canUpdate) return;
                    setModalIsOpen(true);
                    SetUpdateData(row.tbs_offer_id);
                  }}
                />
              ) : (
                ""
              )
            ) : (
              <MdEdit
                size={"1.3vw"}
                color="#1F4B7F"
                className={`${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                onClick={() => {
                  if(!canUpdate) return;
                  setModalIsOpen(true);
                  SetUpdateData(row.tbs_offer_id);
                
                }}
              />
            )}
            <MdDelete
              size={"1.3vw"}
              color="#1F4B7F"
              className={`${canDelete ? "cursor-pointer" : "cursor-not-allowed"}`}
              onClick={() => {
                if(!canDelete) return;
                setDeleteModalIsOpen(true);
                setPromoId(row);
                
              }}
            />
          </div>
        );
      },
    },
  ];
  const [deletemodalIsOpen, setDeleteModalIsOpen] = useState(false);
  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
  };

  return (
    // <div style={{ height: "100%" }} className="table-container">
    <>
      <ModalPopup
        show={statusModal}
        onClose={CloseStatusModal}
        height="22vw"
        width="28vw"
        closeicon={false}
      >
        <>
          <div className="flex flex-col items-center justify-center">
            <p className="text-[1.5vw] font-bold text-[#1F487C]">
              Update the Redeem Offer Status
            </p>
            <img src={Direction} className="h-[6vw] w-[6vw] mt-[1vw]"></img>
            <div className="mt-[1vw] w-[100%] relative">
              <label className="text-[#1F487C] text-[1.3vw] font-bold">
                Comments{" "}
                <span className="text-[.9vw] text-gray-600">{`(Optional for Active)`}</span>{" "}
              </label>
              <input
                type="text"
                name="comments"
                placeholder="Write your comments"
                value={comment}
                onChange={(e) => {
                  const value = e.target.value;
                  setComment(value);
                  setError(value === "" && (id === 3 || id === 4));
                  setMaxError(e.target.value.length > 25);
                }}
                className="border-r-[0.3vw] pl-[1vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1.2vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none placeholder:font-sans placeholder:text-[1vw]"
              />
              {error && (
                <span className="text-[.9vw] text-red-600 absolute bottom-[-1.4vw] left-[0vw]">
                  Comments is required for Reject and Hold
                </span>
              )}

              {maxError === true && (
                <span className="text-[.9vw] text-red-600 absolute bottom-[-1.4vw] left-[0vw]">
                  Comments should not exceed 25 characters
                </span>
              )}
            </div>

            <div className="flex gap-x-[1.5vw] mt-[1.6vw]">
              <button
                className={`items-center text-[1vw] font-extrabold shadow-md shadow-black text-white  space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw] bg-[#2A99FF] rounded-[0.5vw] ${statusId===3?"cursor-not-allowed":"cursor-pointer"}`}              // onClick={() => {
                //   handlechange(4, "On Hold");

                // }}
                onClick={() => handleStatusChange(3)}
                disabled={statusId===3}
              >
                Hold
              </button>
              <button
                className="items-center text-[1vw] text-white shadow-md shadow-black font-extrabold space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw]  bg-[#34AE2B] rounded-[0.5vw]"
                // onClick={() => {
                //   handlechange(5, "Approved");
                // }}
                onClick={() => handleStatusChange(2)}
              >
                Active
              </button>
              <button
                className="items-center text-[1vw] text-white font-extrabold shadow-md shadow-black space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw] bg-[#FD3434] rounded-[0.5vw]"
                // onClick={() => {
                //   handlechange(6, "Rejected");
                // }}
                onClick={() => handleStatusChange(4)}
              >
                Reject
              </button>
            </div>
          </div>
        </>
      </ModalPopup>

      <Table
        dataSource={currentData}
        columns={columns}
        pagination={false}
        className="custom-table"
      />
      <ModalPopup
        show={deletemodalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <DeleteList
          setDeleteModalIsOpen={setDeleteModalIsOpen}
          content={"Want to delete this"}
          title={`${promotionid?.offer_name}`}
          api={`${apiUrl}/redeem-offers-deals/${promotionid?.tbs_offer_id}`}
          module={"redeemoffer"}
          filter={offerFilter}
        />
      </ModalPopup>
      <ModalPopup
        show={offerview}
        onClose={() => setOfferView(false)}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        {console.log(offerimage, "offerss_image")}
        {offerimage === null ? (
          <div className="flex flex-col justify-center items-center w-full h-full pb-[1vw]">
            <CiImageOff size={"6.5vw"} color="#1F487C" />
            <span className="text-[#1F487C] text-[1.3vw] font-semibold mt-[1vw]">
              Image not available
            </span>
          </div>
        ) : (
          <img
            src={`${apiImgUrl}${offerimage}`}
            className="w-full h-[15vw] rounded-[0.5vw] mt-[1vw]"
          />
        )}
      </ModalPopup>
    </>
    // </div>
    // ;{/* <Pagination itemsPerPage={itemsPerPage} items={dataSource} /> */}
  );
}
